import React from 'react'; // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom/client';
import { Main, type CarouselSlide } from './main';

if (process.env.NODE_ENV === 'development') {
  console.log('CBF-VIEW-CUSTOM-CAROUSEL: Loading');
}
let loadApp = function () {
  if (process.env.NODE_ENV === 'development') {
    console.log('CBF-VIEW-CUSTOM-CAROUSEL: Initializing React component');
  }
  const elements = document.getElementsByClassName('cbfcustomcarousel');

  for (const element of elements) {
    const scriptTag = element.querySelector('script[type="application/json"]');
    const rawSlides = scriptTag ? scriptTag.textContent : element.getAttribute('data-slides');

    let slides: CarouselSlide[] = [];

    if (rawSlides) {
      try {
        const parsed = JSON.parse(rawSlides);

        if (Array.isArray(parsed)) {
          slides = parsed;
        }
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.log('CBF-VIEW-CUSTOM-CAROUSEL: Failed to parse slides', error);
        }
      }
    }

    const variant = element.getAttribute('data-variant');
    const itemsPerView = element.getAttribute('data-itemsperview');
    const minCardWidth = element.getAttribute('data-mincardwidth');
    const imageHeight = element.getAttribute('data-imageheight');
    const autoplay = element.getAttribute('data-autoplay');
    const autoplayDelay = element.getAttribute('data-autoplaydelay');
    const loop = element.getAttribute('data-loop');
    const openInNewTab = element.getAttribute('data-openinnewtab');
    const background = element.getAttribute('data-background');
    const cardBackground = element.getAttribute('data-cardbackground');
    const cardTextColor = element.getAttribute('data-cardtextcolor');
    const titleColor = element.getAttribute('data-titlecolor');
    const textAlign = element.getAttribute('data-textalign');
    const buttonBackground = element.getAttribute('data-buttonbackground');
    const buttonTextColor = element.getAttribute('data-buttontextcolor');

    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }

    const root = ReactDOM.createRoot(element);

    root.render(
      <Main
        slides={slides}
        variant={variant ?? ''}
        itemsPerView={itemsPerView ?? ''}
        minCardWidth={minCardWidth ?? ''}
        imageHeight={imageHeight ?? ''}
        autoplay={autoplay ?? ''}
        autoplayDelay={autoplayDelay ?? ''}
        loop={loop ?? ''}
        openInNewTab={openInNewTab ?? ''}
        background={background ?? ''}
        cardBackground={cardBackground ?? ''}
        cardTextColor={cardTextColor ?? ''}
        titleColor={titleColor ?? ''}
        textAlign={textAlign ?? ''}
        buttonBackground={buttonBackground ?? ''}
        buttonTextColor={buttonTextColor ?? ''}
      />,
    );
  }
};
if (document.readyState === 'loading') {
  if (process.env.NODE_ENV === 'development') {
    console.log('CBF-VIEW-CUSTOM-CAROUSEL: Waiting for document ready state');
  }
  document.addEventListener('DOMContentLoaded', loadApp);
} else {
  loadApp();
}
